import ReplyIcon from '@mui/icons-material/Reply'
import { Box, Button } from '@mui/material'
import { useAuth } from 'components/auth/AuthProvider'
import { useRef } from 'react'
import { useTimeSheetStore } from 'stores/timeSheet.store'

export default function StaffAccount() {
  const [staffSelectedCode, setStaffSelectedCode] = useTimeSheetStore((state) => [
    state.staffSelectedCode,
    state.setStaffSelectedCode
  ])
  const anchorRef = useRef(null)
  const auth = useAuth()
  const handleOpen = () => {
    if (auth?.user) {
      setStaffSelectedCode(auth?.user?.staffCode)
    }
  }

  return (
    <Box ref={anchorRef} sx={{ position: 'relative' }}>
      <div className="flex gap-2 items-center">
        {auth?.user?.staffCode !== staffSelectedCode && (
          <Button onClick={handleOpen} startIcon={<ReplyIcon />}>
            Quay về thông tin của tôi
          </Button>
        )}
      </div>
    </Box>
  )
}
